import type { ReactNode } from 'react';
import Header from './Header';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <Header />
      <main className="flex-1 px-6 py-8">
        {/* Jednotná šířka pro všechny stránky. Today feed si uvnitř může shrinknout
            na užší container pro čitelnost karet, admin tabulky využijí celou šířku. */}
        <div className="mx-auto w-full max-w-6xl">{children}</div>
      </main>
    </div>
  );
}
